import styled from 'styled-components';
import { IconButton, Button } from '@material-ui/core';

export const DrawerContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 768px) {
    width: 720px;
  }
`;

export const DrawerHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
  gap: 12px;
`;

export const DrawerHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const DrawerHeaderCloseButton = styled(IconButton)`
  && {
    padding: 8px;
    color: #212121;
  }
`;

export const DrawerHeaderTitle = styled.span`
  font-family: Poppins;
  color: #212121;
  font-weight: 500;
  font-style: Medium;
  font-size: 18px;
`;

export const DrawerHeaderSaveButton = styled(Button).attrs({
  size: 'large',
})`
  align-self: start;

  && {
    padding-left: 20px;
    padding-right: 20px;
    font-family: Poppins;
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    line-height: 1.2;
    color: #004bc4;
    border: 1px solid #004bc4;
    border-radius: 13px;
    background-color: #fff;
    transition: all 0.3s ease-in;
    text-transform: none;

    &:hover {
      background-color: #007ade;
      color: #fff;
    }

    // Override global default styles which set Poppins as font-family for everything
    > .MuiButton-label {
      font-family: inherit;
    }
  }
`;

export const DrawerContent = styled.div`
  flex: 1;
  padding: 24px 20px;
  overflow-y: auto;
`;

export const DrawerTitle = styled.h2`
  font-family: Poppins;
  font-weight: 400;
  font-size: 24px;
  color: #8e8e8e;
  margin: 0 0 24px 0;
`;

export const FormField = styled.div`
  margin-bottom: 24px;
`;

export const FormLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: Poppins;
  font-weight: 500;
  font-size: 18px;
  color: #212121;
  margin-bottom: 8px;
`;

export const FormLabelIcon = styled.span`
  display: flex;
  align-items: center;
  color: #212121;

  svg {
    font-size: 20px;
  }
`;

export const FormInputWrapper = styled.div`
  width: 100%;
`;

export const FormInputDescriptionOptional = styled.span`
  font-family: Poppins;
  font-weight: 400;
  font-size: 16px;
  color: #9b9b9b;
`;
